import axios from 'axios';
const api = axios.create({ baseURL: '/api', timeout: 10000 });
const fetchData = async (endpoint, params = {}) => {
  const response = await api.get(endpoint, { params });
  return response.data;
};
export const getServices = () => fetchData('/services', { sort: 'order:asc', 'filters[isActive][$eq]': true, populate: '*' });
export const getPackagePrices = () => fetchData('/package-prices', { sort: 'order:asc', 'filters[isActive][$eq]': true, populate: '*' });
export const getPageBySlug = (slug) => fetchData('/page-contents', { 'filters[slug][$eq]': slug, populate: '*' });
export const getCtaBlock = () => fetchData('/cta-block', { populate: '*' });
export const getBlogPosts = (limit = 3) => fetchData('/blog-posts', { sort: 'publishedAt:desc', pagination: { limit }, populate: '*' });
export const getBlogPostBySlug = (slug) => fetchData('/blog-posts', { 'filters[slug][$eq]': slug, populate: '*' });
export const getNewsItems = (limit = 20) => fetchData('/news-items', { sort: 'publishedAt:desc', pagination: { limit }, populate: '*' });
export const getNewsItemById = (id) => fetchData(`/news-items/${id}`, { populate: '*' });
export const getFooterSettings = () => fetchData('/footer-setting', { populate: '*' });
export const getContactPageSettings = () => fetchData('/contact-page-setting', { populate: '*' });
export const getAnnouncementBar = () => fetchData('/announcement-bar', { populate: '*' });
export const submitContactForm = async (formData) => {
  const response = await api.post('/contact-submissions', { data: formData });
  return response.data;
};
export default api;
